import { useEffect, useState } from 'react'

export const useWindowWidth = () => {
  const [width, setWidth] = useState(0)
  useEffect(() => {
    const onResize = () => {
      const { innerWidth } = window
      setWidth(innerWidth)
    }
    if (typeof window === 'undefined') {
      return
    }
    window.addEventListener('resize', onResize)
    onResize()
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  return width
}
